module.exports = __webpack_public_path__ + "static/media/pdf.f781501b.svg";